"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _UrlRegexFactory = _interopRequireDefault(require("./factories/UrlRegexFactory"));

var _UrlParts = _interopRequireDefault(require("./parts/UrlParts"));

var URL_WITH_PROTOCOL_REGEX = (0, _UrlRegexFactory.default)({
  protocol: _UrlParts.default.protocolRequired,
  protocolRequired: true
});
var _default = URL_WITH_PROTOCOL_REGEX;
exports.default = _default;
module.exports = exports.default;